<template>
  <div class="success-page" id="print-area">
    <!-- 标题 -->
    <div class="title">{{ pageName }}成功</div>
    <div class="subtitle">您的照片信息已上传</div>

    <!-- 头像展示 -->
    <div class="avatar-container">
      <img :src="userAvatar" alt="用户头像" class="user-avatar" />
    </div>

    <!-- 认证时间 -->
    <div class="certify-time">
      {{ pageName }}时间：{{ certifyTime }}
    </div>
    <div class="certify-time">
      当前时间：{{ nowTimeShow }}
    </div>
    <!-- 签名区域 -->
    <div class="signature-section">
      <div class="section-title" v-if="pageName == '认证'">签名确认</div>
      <div class="signature-area" @click="showSignaturePad" v-if="pageName == '认证'">
        <img v-if="signatureImage" :src="signatureImage" class="signature-image" alt="签名" />
        <div v-else class="signature-placeholder">点击签名</div>
      </div>
      <div class="signature-area" v-else>
        <img v-if="signatureImage" :src="signatureImage" class="signature-image" alt="签名" />
      </div>
    </div>

    <!-- 按钮 -->
    <button class="print-button" @click="handlePrint" v-if="pageName == '认证'">签到</button>
    <button class="print-button" @click="haPrint" v-else>打印</button>
    <!-- 签名板弹窗 -->
    <div v-if="showSignatureModal" class="modal-overlay" @click="closeSignaturePad">
      <div class="signature-modal" @click.stop>
        <div class="modal-header">
          <span>手写签名</span>
          <button class="close-button" @click="closeSignaturePad">×</button>
        </div>
        <canvas ref="signatureCanvas" class="signature-canvas" @touchstart="handleTouchStart"
          @touchmove="handleTouchMove" @mousedown="handleMouseDown" @mousemove="handleMouseMove"
          @mouseup="handleMouseUp" @mouseleave="handleMouseUp"></canvas>
        <div class="modal-footer">
          <button class="clear-button" @click="clearSignature">清除</button>
          <button class="confirm-button" @click="confirmSignature">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
//import VConsole from 'vconsole';
import { firstApi } from '../http/api';

export default {
  name: 'MakeSure',
  data() {
    return {
      userAvatar: '',
      certifyTime: '',
      signatureImage: '', // 保存签名图片
      showSignatureModal: false,
      isDrawing: false,
      certifyId: '',
      nowTimeShow: '',
      timeS: null,
      pageName: '认证'
    };
  },
  created() { 
    this.requestLocation();
  },
  mounted() {
    //window.addEventListener("hashchange", this.handleHashChange);
    // 初始化时检查哈希（防止页面加载时已有坐标）
    //this.handleHashChange();
    
    // 或者始终启用（在真机调试时更方便）
 
    let url = new URL(window.location.href);
    let parms = url.searchParams.get('response')
    console.log('parms:', parms);
    if (parms) {
      this.certifyId = JSON.parse(parms).extInfo.certifyId
    }

    console.log('certifyId:', this.certifyId);
    if (this.$route.query.code == '1000') {
      this.certifyId = this.$route.query.certifyId
    }
    else if (JSON.parse(parms).code != '1000') {
      //todo 跳转错误页面
      this.$router.push({
        path: '/signin',
        query: {
          code: JSON.parse(parms).code,
          subCode: JSON.parse(parms).subCode
        }
      });
    }
    if (this.certifyId) {
      this.getUserAvatar();

      this.timeS = setInterval(() => {
        this.nowTimeShow = this.nowTime();
      }, 1000);
    }

    // try {
    //   const vConsole = new VConsole();
    //   console.log('vconsole 初始化成功', vConsole);
    //   // 强制显示 vconsole 面板
    //   setTimeout(() => {
    //     if (vConsole && typeof vConsole.show === 'function') {
    //       vConsole.show();
    //       console.log('vconsole 已显示');
    //     }
    //   }, 1000);

    // } catch (error) {
    //   console.error('vconsole 初始化失败:', error);
    // }
  },
  methods: {
      handleHashChange() {
      const hash = window.location.hash.slice(1); // 去掉 #
      if (!hash) return;

      // 接收小程序回传的坐标
      if (hash.includes("location=")) {
        try {
          const locationStr = hash.split("location=")[1];
          this.location = JSON.parse(decodeURIComponent(locationStr));
          console.log("H5 接收坐标：", this.location);
          alert("已获取定位");
        } catch (err) {
          alert("解析坐标失败：");
          console.error("解析坐标失败：", err);
        }
      }

      // 接收定位失败信息
      if (hash.includes("locationError=")) {
        const errorStr = hash.split("locationError=")[1];
        const error = JSON.parse(decodeURIComponent(errorStr));
        alert(`定位失败：${error.errMsg}`);
      }
    },
     requestLocation() {
      if (!window.wx) {
        alert("请在小程序内打开");
        return;
      }
      const hash = window.location.hash.slice(1); // 去掉 #
      
      if (hash.includes("getLocation=")) {
        return;
      }
      // 核心：修改哈希（加随机数，确保每次触发 onLoad）
      const random = Date.now(); // 用时间戳替代随机数，避免重复

      window.location.hash = `#getLocation=${random}`;
      // 可选：若哈希修改后仍不触发，可强制修改完整 URL（无刷新）
      // window.location.href = `${window.location.origin}${window.location.pathname}#getLocation=${random}`;
    },
    haPrint() {
      // 打印调用打印机
      // 小程序端使用 uni.printer
      const printArea = document.getElementById('print-area'); // 假设有一个ID为print-area的区域是要打印的
      const content = printArea.innerText || printArea.textContent;
      if (window.__wxjs_environment === 'miniprogram') {
        // 通过 postMessage 通知小程序执行打印
        // wx.miniProgram.postMessage({
        //   data: { action: 'print' },
        //   content
        // });
        const token = localStorage.getItem('token');
        // 可选：通知小程序关闭当前 web-view 页面 /pages/loding/loding
        wx.miniProgram.navigateTo({
          url: `/pages/searchProint/searchProint?token=${token}`
        });
      } else {
        // 普通浏览器环境
        window.print();
      }
    },
    nowTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    //认证成功查询头像
    getUserAvatar() {
      firstApi.queryFaceVerifyImage({ certifyId: this.certifyId }).then(res => {
        console.log(res, '头像');
        if (res.code == 1) {
          this.userAvatar = res.data.pictureUrl;
          this.certifyTime = res.data.authDate;
        } else if (res.code == 1001) {
          localStorage.removeItem('token');
          this.$router.push({
            path: '/signin',
          });
        } else {
          this.userAvatar = '';
        }
      });
    },

    // 显示签名板
    showSignaturePad() {
      this.showSignatureModal = true;
      this.$nextTick(() => {
        this.initCanvas();
      });
    },

    // 关闭签名板
    closeSignaturePad() {
      this.showSignatureModal = false;
    },

    // 初始化 Canvas
    initCanvas() {
      const canvas = this.$refs.signatureCanvas;
      const ctx = canvas.getContext('2d');

      // 设置 Canvas 大小
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;

      // 设置绘图样式
      ctx.strokeStyle = '#000';
      ctx.lineWidth = 2;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
    },

    // 触摸开始
    handleTouchStart(e) {
      e.preventDefault();
      const canvas = this.$refs.signatureCanvas;
      const rect = canvas.getBoundingClientRect();
      const touch = e.touches[0];
      const x = touch.clientX - rect.left;
      const y = touch.clientY - rect.top;

      this.startDrawing(x, y);
    },

    // 触摸移动
    handleTouchMove(e) {
      e.preventDefault();
      const canvas = this.$refs.signatureCanvas;
      const rect = canvas.getBoundingClientRect();
      const touch = e.touches[0];
      const x = touch.clientX - rect.left;
      const y = touch.clientY - rect.top;

      this.draw(x, y);
    },

    // 鼠标按下
    handleMouseDown(e) {
      const canvas = this.$refs.signatureCanvas;
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      this.startDrawing(x, y);
    },

    // 鼠标移动
    handleMouseMove(e) {
      if (!this.isDrawing) return;

      const canvas = this.$refs.signatureCanvas;
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      this.draw(x, y);
    },

    // 鼠标抬起
    handleMouseUp() {
      this.isDrawing = false;
    },

    // 开始绘制
    startDrawing(x, y) {
      this.isDrawing = true;
      const ctx = this.$refs.signatureCanvas.getContext('2d');
      ctx.beginPath();
      ctx.moveTo(x, y);
    },

    // 绘制过程
    draw(x, y) {
      if (!this.isDrawing) return;

      const ctx = this.$refs.signatureCanvas.getContext('2d');
      ctx.lineTo(x, y);
      ctx.stroke();
    },

    // 清除签名
    clearSignature() {
      const canvas = this.$refs.signatureCanvas;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    },

    // 确认签名
    confirmSignature() {
      const canvas = this.$refs.signatureCanvas;
      this.signatureImage = canvas.toDataURL('image/png');
      this.closeSignaturePad();
    },
    async handlePrint() {
      // 判断是否已签名
      if (!this.signatureImage) {
        alert('请先完成签名');
        return;
      }

      try {
        // 调用后端接口上传签名图片
        await this.uploadSignature(this.signatureImage);

        // 上传成功后执行打印
        // window.print();
      } catch (error) {
        console.error('签名上传失败:', error);
        alert('签到失败，请重试');
      }
    },

    // 新增：上传签名到后端的方法
    async uploadSignature(signatureData) {
      // 这里需要替换为实际的API调用
      // 示例使用fetch API，也可以使用axios等其他HTTP库
      await firstApi.saveExamSign({ signBase64: signatureData, certifyId: this.certifyId }).then(response => {
        console.log(response)
        if (response.code == 1) {
          alert('签到成功')
          this.$router.push({
            path: '/overRitht',
            query: { certifyId: this.certifyId }
          });

        } else if (response.code == 1001) {
          localStorage.removeItem('token');
          this.$router.push({
            path: '/signin',
          });
        } else {
          alert(response.msg)
        }
      });
      return
    }
  },
  beforeDestroy() {
    clearInterval(this.timeS);
  }
};
</script>

<style scoped>
.success-page {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 40px 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.title {
  font-weight: 800;
  font-size: 22px;
  color: #323233;
  margin-bottom: 8px;
}

.subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
}

.avatar-container {
  width: 144px;
  height: 144px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.certify-time {
  font-weight: bold;
  font-size: 20px;
  color: #323233;
  margin-bottom: 30px;
  text-align: left;
}

.signature-section {
  width: 100%;
  max-width: 350px;
  margin-bottom: 30px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  text-align: left;
}

.signature-area {
  width: 100%;
  height: 176px;
  background-color: #f0f2f5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px dashed #ccc;
  position: relative;
  overflow: hidden;
}

.signature-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.signature-placeholder {
  font-size: 16px;
  color: #999;
  text-align: center;
}

.print-button {
  position: fixed;
  bottom: 50px;
  width: 330px;
  height: 40px;
  line-height: 40px;
  background: #4C7AF3;
  color: white;
  border: none;
  border-radius: 21px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.print-button:hover {
  background-color: #0056b3;
}

/* 签名板弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.signature-modal {
  width: 90%;
  max-width: 400px;
  background: white;
  border-radius: 10px;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.modal-header span {
  font-weight: bold;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.signature-canvas {
  width: 100%;
  height: 200px;
  background-color: #f9f9f9;
  touch-action: none;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  padding: 15px;
}

.clear-button,
.confirm-button {
  padding: 8px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.clear-button {
  background-color: #f0f2f5;
  color: #333;
}

.confirm-button {
  background-color: #007bff;
  color: white;
}
</style>